var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.tips)+"%")]),_c('Echart',{ref:"echart",attrs:{"options":_vm.options,"id":"centreLeft1Chart","width":"100%","height":"100%"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }